import { useEffect, useRef } from 'react';
import type { IMobileAdUnitInfo } from '~/utils/i-mobile-constants';

export const useInitAd = (unit: IMobileAdUnitInfo) => {
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    if (hasInitializedRef.current) return;

    // 外部スクリプトを動的に作成して追加
    const script = document.createElement('script');
    script.id = 'i-mobile-spot';
    script.async = true;
    script.src = '//imp-adedge.i-mobile.co.jp/script/v1/spot.js?20220104';
    document.body.append(script);

    // @ts-ignore
    (window.adsbyimobile = window.adsbyimobile || []).push({
      pid: unit.pid,
      mid: unit.mid,
      asid: unit.asid,
      type: unit.type,
      display: unit.display,
      elementid: unit.elementid,
    });

    hasInitializedRef.current = true;
  }, [unit]);
};
